export default __webpack_public_path__ + "static/media/dashboard-4.abaeda37.png";